<template>
  <div class="form-control" :class="{ 'has-error': validation.hasError('mirror') }">
    <div class="input-group input-group-sm"> 
      <datepicker
        ref="programaticOpen"
        :disabled-dates="disabledDates"
        :format="format"
        :value="modelo.fecha"
        @input="fechaSelect"
        :typeable="!xautogenerarfechas"
        :clear-button="(xindice==0 && xautogenerarfechas)"
        :language="espanol"
        :title="(xindice>0 && xautogenerarfechas)?'Para editar desactive: auto cambiar fechas':''"
        :disabled="(xindice>0 && xautogenerarfechas)" 
        :style="(xindice>0 && xautogenerarfechas)?'background: #ededed;':''"
        placeholder="Formato DD/MM/YYYY"></datepicker>
    </div>
    <div class="error" v-if="validation.hasError('mirror')">{{ validation.firstError('mirror') }}</div>
  </div>
</template>

<style lang="css">
  input[autocomplete='off'] {
    width: 90%;
  }
  input[placeholder='Formato DD/MM/YYYY']:focus {
    outline: none;
  }
</style>

<script>
  import Datepicker from '@hokify/vuejs-datepicker';
  import { Validator } from 'simple-vue-validator';
  import '@hokify/vuejs-datepicker/dist/vuejs-datepicker.css'; // include CSS
  export default {
    props: {
      model: Object,
      valueto: { type: String, required: false, default: null },
      default: { type: String, required: false, default: null },
      datenewrest: { type: Boolean, required: false, default: false }, // para indicar que la fecha es en formato: dd/mm/yyyy
      xplanes: { type: Object, required: true },
      xautogenerarfechas: { type: Boolean, required: true },
      xindice: {type:Number,default:-1},
      xisgenerarplan: {type:Boolean,default:false}
    },
    data() {
      return {
        espanol: 'es',
        format: 'DD/MM/YYYY',
        mirror: null, // permite validar la fecha, pero no es la que se usa
        datos: [],
        modelo: {
          fecha: null,
        },
        disabledDates: {
          to: new Date(2016, 0, 5),
        },
      };
    },
    components: { Datepicker },
    watch: {
      default: function () {
        //window.console.log( 'AFECHAx: ',this.default,this.default.length );
        this.parseDefault();
      },
    },
    validators: {
      'modelo.fecha'(value) {
        return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
      },
      mirror(value) {
        if (this.datenewrest) return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
        else return Validator.value(value).regex('^[0-9]{4}-[0-9]{2}-[0-9]{2}$'); // al server anio-mes-dia
      },
    },
    methods: {
      openPicker() {
        this.$refs.programaticOpen.showCalendar();
      },
      customFormatter(date) {
        return this.$moment(date).format('dd/MM/yyyy');
      },
      fechaSelect(dat) { 
        var date = dat;
        //window.console.log( '1 HOLA::',dat );
        if (!date) return;
        let anio_valido = date.getFullYear();
        //window.console.log( 'anio_valido::',anio_valido );
        if (anio_valido < 2013) return;
        //window.console.log( '2 HOLA::',dat );
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var a = date.getFullYear();
        if (d < 10) d = '0' + d;
        if (m < 10) m = '0' + m;
        var fec = a + '-' + m + '-' + d;
        if (this.datenewrest) {
          fec = d + '/' + m + '/' + a;
        }
        if (this.valueto) this.model[this.valueto] = fec;
        else this.model.fecha = fec;
        // window.console.log('set fecha:', this.model);
        this.mirror = fec;

        const fff = a + '-' + m + '-' + d
        this.$emit('fecha_changed',fff)

        if (this.xautogenerarfechas) {
          window.console.log(JSON.stringify(this.model, null, 4));
          window.console.log('----\n\n');
          window.console.log(JSON.stringify(this.xplanes, null, 4));

          /* const vue = this;
          setTimeout(() => {
            //vue.regenerarfechas();
            vue.regenerarFechas2();
          }, 500); */
        }
      }, 
      regenerarFechas2() {
        let fecha_limite = 15;
        let modelo = JSON.parse(JSON.stringify(this.model));
        let pago = this.xplanes.cobros.find((x) => x.cobro_programa_id == this.model.cobro_programa_id);

        let fs = modelo.fecha_pago.split('/');
        let f = `${fs[2]}-${fs[1]}-${fs[0]}`;
        let date = new Date(f);
        date.setHours(date.getHours() + 4);
        if (date.getDate() > fecha_limite) date.setDate(fecha_limite);

        let fechas_antes = [];
        let fechas_despues = [];

        for (let i = 0; i < modelo.nro_cuota; i++) {
          let fecha_new = new Date(date);
          let xfe = new Date(fecha_new - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
          let fs = xfe.split('-');
          let fe = `${fs[2]}/${fs[1]}/${fs[0]}`;
          fechas_antes.push({ xfecha: xfe, fecha: fe, nro: modelo.nro_cuota - i });
          date.setMonth(date.getMonth() - 1);
        }

        date.setMonth(date.getMonth() + modelo.nro_cuota);
        fechas_antes.reverse();

        for (let i = modelo.nro_cuota; i < pago.pagos.length + 1; i++) {
          let fecha_new = new Date(date);
          let xfe = new Date(fecha_new - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
          let fs = xfe.split('-');
          let fe = `${fs[2]}/${fs[1]}/${fs[0]}`;
          fechas_despues.push({ xfecha: xfe, fecha: fe, nro: i });
          date.setMonth(date.getMonth() + 1);
        }

        let unido = fechas_antes.concat(fechas_despues);

        unido.forEach((x) => {
          if (x.nro != modelo.nro_cuota) {
            let xpago = pago.pagos.find((p) => p.nro_cuota == x.nro);
            xpago.xfecha_pago = x.xfecha;
            xpago.fecha_pago = x.fecha;
          }
        });

        // si se esta editando fechas en colegiatura
        if (pago.concepto_id == 2) {
          this.modificarFechaMatricula(pago, unido);
          this.modificarFechaCertifica(pago, unido);
        }
      },
      modificarFechaMatricula(pago, unido) {
        if (pago.concepto_id != 1) {
          let pagos_matri = this.xplanes.cobros.find((x) => x.concepto_id == 1);
          if (pagos_matri) {
            let fecha_ini = unido[0];
            pagos_matri.pagos.forEach((x) => {
              x.xfecha_pago = fecha_ini.xfecha;
              x.fecha_pago = fecha_ini.fecha;
            });
          }
        }
      },
      modificarFechaCertifica(pago, unido) {
        if (pago.concepto_id != 3) {
          let pagos_matri = this.xplanes.cobros.find((x) => x.concepto_id == 3);
          if (pagos_matri) {
            let max = unido.length - 1;
            if (max < 0) max = 0;
            let fecha_ini = unido[max];
            pagos_matri.pagos.forEach((x) => {
              x.xfecha_pago = fecha_ini.xfecha;
              x.fecha_pago = fecha_ini.fecha;
            });
          }
        }
      },

      parseDefault() {
        if (this.default) {
          var ps = this.default.split('-');
          var def = ps[1] + '/' + ps[2] + '/' + ps[0];
          this.modelo.fecha = def;
          var fec = ps[0] + '-' + ps[1] + '-' + ps[2];
          if (this.datenewrest) {
            fec = ps[2] + '/' + ps[1] + '/' + ps[0];
          }

          if (this.valueto) this.model[this.valueto] = fec;
          else this.model.fecha = fec;
        }
      },
    },
    mounted() {
      this.$validate().then(() => {});
      this.parseDefault();
    },
  };
</script>
